import React from 'react';

interface InstanceStatusLike {
  instanceId: string;
  syncStatus: 'unknown' | 'aligned' | 'drifted' | 'needs_review' | 'error';
  lastError?: string | null;
}

interface ScopeDriftBannerProps {
  statuses: InstanceStatusLike[];
}

/**
 * Top-of-page banner shown only when one or more installations report a
 * non-aligned Scope sync state. Answers the admin's first question
 * ("is anything wrong?") before they read the rest of the page.
 */
export const ScopeDriftBanner: React.FC<ScopeDriftBannerProps> = ({ statuses }) => {
  const affected = statuses.filter((status) => (
    status.syncStatus === 'drifted'
    || status.syncStatus === 'needs_review'
    || status.syncStatus === 'error'
  ));
  if (affected.length === 0) {
    return null;
  }
  const drifted = affected.filter((status) => status.syncStatus === 'drifted').length;
  const needsReview = affected.filter((status) => status.syncStatus === 'needs_review').length;
  const errored = affected.filter((status) => status.syncStatus === 'error').length;
  const parts: string[] = [];
  if (drifted) parts.push(`${drifted} drifted`);
  if (needsReview) parts.push(`${needsReview} needing review`);
  if (errored) parts.push(`${errored} reporting an error`);
  return (
    <div className="scopes-drift-banner" role="status">
      <span className="icon" aria-hidden="true">⚠️</span>
      <span className="text">
        <strong>{affected.length} installation{affected.length === 1 ? '' : 's'}</strong>{' '}
        report Scope sync issues ({parts.join(', ')}). See Installation status below for the per-instance detail.
      </span>
    </div>
  );
};

export default ScopeDriftBanner;
